import React, { MouseEventHandler } from 'react';
import { styled as muiStyled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import MuiIconButton from '@mui/material/IconButton';
import { DialogTitleProps } from '@mui/material/DialogTitle';
import DialogTitle from './DialogTitle';

interface Props extends DialogTitleProps {
  onClose: MouseEventHandler<HTMLButtonElement>;
}

// 「x」アイコンボタン（閉じるボタン）付きのダイアログタイトル
// アイコンボタンを付ける場合は背景をクリックした際の閉じる動作を無効にする
// <Dialog disableBackdropClick>
const DialogTitleWithCloseButton = ({ onClose, children, ...rest }: Props) => {
  return (
    <DialogTitle {...rest}>
      <Typography component="div" variant="body1">
        {children}
      </Typography>
      <StyledIconButton aria-label="close" onClick={onClose}>
        <CloseIcon />
      </StyledIconButton>
    </DialogTitle>
  );
};

export default DialogTitleWithCloseButton;

const StyledIconButton = muiStyled(MuiIconButton)(
  ({ theme }) => `
    position: absolute;
    right: ${theme.spacing(2)};
    top: ${theme.spacing(2)};
`,
);
